import {
  EmailTemplateSavePayload,
  EmailEditorConfig,
  SystemEmailTemplate
} from "model/SystemEmailTemplate";
import {
  EmailEditorConfigDto,
  SystemEmailTemplateDto,
  SystemEmailTemplateSavePayloadDto
} from "./SystemEmailTemplatesDtos";

/**
 * Snake_case → camelCase. The full-only fields (html, designJson, marketplaceId,
 * createdAt) are only populated when the DTO came from the show / create / update
 * endpoints; index responses leave them undefined.
 */
export const convertSystemEmailTemplate = (dto: SystemEmailTemplateDto): SystemEmailTemplate => ({
  id: dto.id,
  uuid: dto.uuid,
  name: dto.name,
  category: dto.category,
  subjectDefault: dto.subject_default,
  system: dto.system,
  published: dto.published,
  updatedAt: dto.updated_at,
  html: dto.html,
  designJson: dto.design_json,
  marketplaceId: dto.marketplace_id,
  createdAt: dto.created_at
});

export const convertEmailEditorConfig = (dto: EmailEditorConfigDto): EmailEditorConfig => ({
  projectId: dto.project_id,
  userId: dto.user_id,
  signature: dto.signature,
  mergeTags: dto.merge_tags.map(t => ({ name: t.name, value: t.value }))
});

/**
 * Domain create/update payload → backend DTO. The thunk wraps this under
 * `email_template` before sending.
 */
export const convertSavePayloadToDto = (
  payload: EmailTemplateSavePayload
): SystemEmailTemplateSavePayloadDto => ({
  name: payload.name,
  category: payload.category,
  html: payload.html,
  design_json: payload.designJson,
  published: payload.published
});
